export const getInspectionsType = {
  GET_INSPECTION_PENDING: "[GET_INSPECTION_PENDING] Get Inspection Data",
  GET_INSPECTION_SUCCESS:
    "[GET_INSPECTION_PENDINGSUCCESS] Get Inspection Successfull",
  GET_INSPECTION_FAILURE:
    "[GET_INSPECTION_PENDINGFAILURE] Get Inspection Failed",
};

export const getDropdownDataKeyValueType = {
  GET_DROPDOWN_DATA_KEY_VALUE_PENDING:
    "[GET_DROPDOWN_DATA_KEY_VALUE_PENDING] Get Dropdown Value  Data",
  GET_DROPDOWN_DATA_KEY_VALUE_SUCCESS:
    "[GET_DROPDOWN_DATA_KEY_VALUE_SUCCESS] Get Dropdown Value  Successfull",
  GET_DROPDOWN_DATA_KEY_VALUE_FAILURE:
    "[GET_DROPDOWN_DATA_KEY_VALUE_FAILURE] Get Dropdown Value  Failed",
};

export const getSupervisorByProjectType = {
  GET_SUPERVISOR_BY_PROJECT_PENDING:
    "[GET_SUPERVISOR_BY_PROJECT] GET SUPERVISOR BY PROJECT Data",
  GET_SUPERVISOR_BY_PROJECT_SUCCESS:
    "[GET_SUPERVISOR_BY_PROJECT_SUCCESS] GET SUPERVISOR BY PROJECT Successfull",
  GET_SUPERVISOR_BY_PROJECT_FAILURE:
    "[GET_SUPERVISOR_BY_PROJECT_FAILURE] GET SUPERVISOR BY PROJECT Failed",
  SUPERVISOR_BY_PROJECT_PAGE: "SUPERVISOR_BY_PROJECT_Page",
};
export const thirdPartyApiType = {
  GET_GET_OSHA_TOKEN_DETAILS_PENDING:
    "[GET_GET_OSHA_TOKEN_DETAILS] GET OSHA TOKEN DETAILS Data",
  GET_GET_OSHA_TOKEN_DETAILS_SUCCESS:
    "[GET_GET_OSHA_TOKEN_DETAILS_SUCCESS] GET OSHA TOKEN DETAILS Successfull",
  GET_GET_OSHA_TOKEN_DETAILS_FAILURE:
    "[GET_GET_OSHA_TOKEN_DETAILS_FAILURE] GET OSHA TOKEN DETAILS Failed",
  GET_OSHA_TOKEN_DETAILS_PAGE: "GET OSHA TOKEN DETAILS Page",
  POST_ADD_OSHA_TOKEN_PENDING: "[Add Osha tOKEN][REQUEST] POST_ADD_OSHA_TOKEN",
  POST_ADD_OSHA_TOKEN_FAILURE:
    "[Add Osha tOKEN][RESPONSE] POST_ADD_OSHA_TOKEN Failed",
  POST_ADD_OSHA_TOKEN_SUCCESS:
    "[Add Osha tOKEN][RESPONSE] POST_ADD_OSHA_TOKEN Successfull",
  CLEAR_OSHA_TOKEN: "[CLEAR_OSHA_TOKEN] clear osha token",
  POST_ADD_OSHA_TOKEN_PAGE: "POST_ADD_OSHA_TOKEN_Page",
};
